import createCrudModule from 'vuex-crud';
import {client, parseResponse} from '@/api'

export default createCrudModule({
  resource: 'projects',
  idAttribute: 'slug',
  client,
  parseSingle: parseResponse,
  parseList: parseResponse,
  customUrlFn(slug) {
    return slug ? process.env.VUE_APP_API+`api/projects/view/${slug}` :  process.env.VUE_APP_API+'api/projects';
  }
});
